<nx-pageTitle-box
  [label]="'core.companyViewComponent.pageTitle.label' | translate"
  [bcRootLvlLabel]="'core.companyViewComponent.breadcrumb.rootLabel' | translate"
  [bcRootLvlPath]="'settings'"
  [icon]="'icon-company'"
  [iconToolTip]="'core.companyViewComponent.pageTitle.iconTooltip' | translate">
  <ng-template nxTemplate="end">
    <nx-default-button
      (click)="editCompany()"
      [tooltip]="'core.companyViewComponent.editButton.tooltip' | translate"
      [icon]="'icon-edit'">

    </nx-default-button>
  </ng-template>
</nx-pageTitle-box>

<div class="flex flex-row gap-4 mt-2">
  <div
    class="basis-1/2">
    <nx-headline-box  
      [label]="'core.companyViewComponent.companyData.headline' | translate">
    </nx-headline-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'core.companyViewComponent.companyData.name' | translate">
      {{tenant?.name}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'core.companyViewComponent.companyData.additionalName' | translate">
      {{tenant?.additionalName}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'core.companyViewComponent.companyData.tenantId' | translate">
      {{tenant?.tenantId}}
      <ng-template nxTemplate="end">
        <nx-default-button
        [style]="'light'"
        class="ml-2"
        [tooltip]="'core.companyViewComponent.copyButton.tooltip' | translate"
        (click)="copyToClipboard(tenant?.tenantId)"
        [icon]="'icon-copy'">
      </nx-default-button>
      </ng-template>

    </nx-default-box>

    <nx-headline-box
      class="mt-2"
      [label]="'core.companyViewComponent.contactData.headline' | translate">
    </nx-headline-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'core.companyViewComponent.contactData.email' | translate">
      {{tenant?.email}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'core.companyViewComponent.contactData.phone' | translate">
      {{tenant?.phone}}
    </nx-default-box> 

    <nx-headline-box  
      class="mt-2"
    [label]="'core.companyViewComponent.taxInfo.headline' | translate">
    </nx-headline-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'core.companyViewComponent.taxInfo.vatType' | translate">
      {{getVatType(tenant?.vatType)}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'core.companyViewComponent.taxInfo.vatNumber' | translate">
      {{tenant?.vatNumber}}
    </nx-default-box>
  </div>
  <div
    class="basis-1/2">
    <nx-headline-box  
      [label]="'core.companyViewComponent.address.headline' | translate">
    </nx-headline-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'core.companyViewComponent.address.line1' | translate">
      {{tenant?.addressLine0}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'core.companyViewComponent.address.line2' | translate">
      {{tenant?.addressLine1}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'core.companyViewComponent.address.postalCode' | translate">
      {{tenant?.postalCode}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'core.companyViewComponent.address.city' | translate">
      {{tenant?.city}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'core.companyViewComponent.address.country' | translate">
      {{tenant?.country}}
    </nx-default-box>
  </div>
</div>

